import { render, staticRenderFns } from "./auditgoodsdetail.vue?vue&type=template&id=2d0c3845&scoped=true"
import script from "./auditgoodsdetail.vue?vue&type=script&lang=js"
export * from "./auditgoodsdetail.vue?vue&type=script&lang=js"
import style0 from "./auditgoodsdetail.vue?vue&type=style&index=0&id=2d0c3845&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c3845",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d0c3845')) {
      api.createRecord('2d0c3845', component.options)
    } else {
      api.reload('2d0c3845', component.options)
    }
    module.hot.accept("./auditgoodsdetail.vue?vue&type=template&id=2d0c3845&scoped=true", function () {
      api.rerender('2d0c3845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditcenter/auditgoodsdetail.vue"
export default component.exports